import { render, staticRenderFns } from "./subscriptions.dialog.vue?vue&type=template&id=be4f0f52&"
import script from "./subscriptions.dialog.vue?vue&type=script&lang=js&"
export * from "./subscriptions.dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports